import { SpineVirtualMesh } from "../mesh/SpineVirtualMesh";
import { SpineNormalRenderBase } from "./SpineNormalRenderBase";
const QUAD_TRIANGLES = [0, 1, 2, 2, 3, 0];
export class SpineSkeletonRenderer extends SpineNormalRenderBase {
    createMesh(material) {
        return new SpineVirtualMesh(material);
    }
    constructor(templet) {
        super();
        this.tempColor = new window.spine.Color();
        this.tempColor2 = new window.spine.Color();
        this.templet = templet;
        if (SpineSkeletonRenderer.vertices == null) {
            SpineSkeletonRenderer.vertices = spine.Utils.newFloatArray(12 * 1024);
        }
        this.renderable = { vertices: null, numVertices: 0, numFloats: 0 };
        this.clipper = new spine.SkeletonClipping();
    }
    draw(skeleton, renderNode, slotRangeStart, slotRangeEnd) {
        let clipper = this.clipper;
        this.clearBatch();
        let twoColorTint = true;
        let blendMode = null;
        let renderable = this.renderable;
        let uvs;
        let triangles;
        let drawOrder = skeleton.drawOrder;
        let attachmentColor;
        let skeletonColor = skeleton.color;
        let vertexSize = SpineVirtualMesh.vertexSize_TwoColor;
        let inRange = false;
        if (slotRangeStart == -1)
            inRange = true;
        let virtualMesh;
        let spineTex;
        let staticVetices = SpineSkeletonRenderer.vertices;
        for (let i = 0, n = drawOrder.length; i < n; i++) {
            let clippedVertexSize = clipper.isClipping() ? 2 : vertexSize;
            let slot = drawOrder[i];
            if (!slot.bone.active) {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (slotRangeStart >= 0 && slotRangeStart == slot.data.index) {
                inRange = true;
            }
            if (!inRange) {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (slotRangeEnd >= 0 && slotRangeEnd == slot.data.index) {
                inRange = false;
            }
            let attachment = slot.getAttachment();
            let texture;
            if (attachment instanceof window.spine.RegionAttachment) {
                let region = attachment;
                renderable.vertices = staticVetices;
                renderable.numVertices = 4;
                renderable.numFloats = clippedVertexSize << 2;
                if (attachment.sequence != null)
                    attachment.sequence.apply(slot, attachment);
                this.computeWorldVertices_RegionAttachment(region, slot.bone, renderable.vertices, 0, clippedVertexSize, -skeleton.x, -skeleton.y);
                triangles = QUAD_TRIANGLES;
                uvs = region.uvs;
                texture = region.region.page.texture;
                attachmentColor = region.color;
            }
            else if (attachment instanceof window.spine.MeshAttachment) {
                let mesh = attachment;
                renderable.vertices = staticVetices;
                renderable.numVertices = (mesh.worldVerticesLength >> 1);
                renderable.numFloats = renderable.numVertices * clippedVertexSize;
                if (renderable.numFloats > renderable.vertices.length) {
                    renderable.vertices = staticVetices = window.spine.Utils.newFloatArray(renderable.numFloats);
                }
                if (attachment.sequence != null)
                    attachment.sequence.apply(slot, attachment);
                this.computeWorldVertices_MeshAttachment(mesh, slot, 0, mesh.worldVerticesLength, renderable.vertices, 0, clippedVertexSize, -skeleton.x, -skeleton.y);
                triangles = mesh.triangles;
                texture = mesh.region.page.texture;
                uvs = mesh.uvs;
                attachmentColor = mesh.color;
            }
            else if (attachment instanceof window.spine.ClippingAttachment) {
                let clip = (attachment);
                this.clipStart(this.clipper, slot, clip, -skeleton.x, -skeleton.y);
                continue;
            }
            else {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (texture) {
                let slotColor = slot.color;
                let finalColor = this.tempColor;
                finalColor.r = skeletonColor.r * slotColor.r * attachmentColor.r;
                finalColor.g = skeletonColor.g * slotColor.g * attachmentColor.g;
                finalColor.b = skeletonColor.b * slotColor.b * attachmentColor.b;
                finalColor.a = skeletonColor.a * slotColor.a * attachmentColor.a;
                let darkColor = this.tempColor2;
                if (!slot.darkColor)
                    darkColor.set(0, 0, 0, 1.0);
                else {
                    darkColor.setFromColor(slot.darkColor);
                }
                let slotBlendMode = slot.data.blendMode;
                let needNewMat = false;
                if (slotBlendMode != blendMode) {
                    blendMode = slotBlendMode;
                    needNewMat = true;
                }
                if (spineTex != texture) {
                    spineTex = texture;
                    needNewMat = true;
                }
                if (needNewMat) {
                    virtualMesh && virtualMesh.draw();
                    let mat = renderNode.templet.getMaterial(texture.realTexture, blendMode);
                    virtualMesh = this.nextBatch(mat, renderNode);
                    virtualMesh.clear();
                }
                if (clipper.isClipping()) {
                    clipper.clipTriangles(renderable.vertices, renderable.numFloats, triangles, triangles.length, uvs, finalColor, darkColor, twoColorTint);
                    if (!virtualMesh.canAppend(clipper.clippedVertices.length, clipper.clippedTriangles.length)) {
                        virtualMesh.draw();
                        virtualMesh = this.nextBatch(virtualMesh.material, renderNode);
                        virtualMesh.clear();
                    }
                    virtualMesh.appendVerticesClip(clipper.clippedVertices, clipper.clippedTriangles);
                }
                else {
                    if (!virtualMesh.canAppend(renderable.numFloats, triangles.length)) {
                        virtualMesh.draw();
                        virtualMesh = this.nextBatch(virtualMesh.material, renderNode);
                        virtualMesh.clear();
                    }
                    if (finalColor.a != 0) {
                        virtualMesh.appendVertices(renderable.vertices, renderable.numFloats, triangles, triangles.length, finalColor, darkColor, uvs);
                    }
                }
            }
            clipper.clipEndWithSlot(slot);
        }
        clipper.clipEnd();
        virtualMesh && virtualMesh.draw();
    }
    clipStart(clipper, slot, clip, ofx, ofy) {
        if (clipper.clipAttachment)
            return 0;
        clipper.clipAttachment = clip;
        let n = clip.worldVerticesLength;
        let vertices = spine.Utils.setArraySize(clipper.clippingPolygon, n);
        this.computeWorldVertices_MeshAttachment(clip, slot, 0, n, vertices, 0, 2, ofx, ofy);
        let clippingPolygon = clipper.clippingPolygon;
        spine.SkeletonClipping.makeClockwise(clippingPolygon);
        let clippingPolygons = clipper.clippingPolygons = clipper.triangulator.decompose(clippingPolygon, clipper.triangulator.triangulate(clippingPolygon));
        for (let i = 0, n = clippingPolygons.length; i < n; i++) {
            let polygon = clippingPolygons[i];
            spine.SkeletonClipping.makeClockwise(polygon);
            polygon.push(polygon[0]);
            polygon.push(polygon[1]);
        }
        return clippingPolygons.length;
    }
    computeWorldVertices_RegionAttachment(attachment, bone, worldVertices, offset, stride, ofx, ofy) {
        let vertexOffset = attachment.offset;
        let x = bone.worldX + ofx, y = bone.worldY + ofy;
        let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
        let offsetX = 0, offsetY = 0;
        offsetX = vertexOffset[0];
        offsetY = vertexOffset[1];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[2];
        offsetY = vertexOffset[3];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[4];
        offsetY = vertexOffset[5];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[6];
        offsetY = vertexOffset[7];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
    }
    computeWorldVertices_MeshAttachment(attachment, slot, start, count, worldVertices, offset, stride, ofx, ofy) {
        count = offset + (count >> 1) * stride;
        let skeleton = slot.bone.skeleton;
        let deformArray = slot.deform;
        let vertices = attachment.vertices;
        let bones = attachment.bones;
        if (bones == null) {
            if (deformArray.length > 0)
                vertices = deformArray;
            let bone = slot.bone;
            let x = bone.worldX + ofx;
            let y = bone.worldY + ofy;
            let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
            for (let v = start, w = offset; w < count; v += 2, w += stride) {
                let vx = vertices[v], vy = vertices[v + 1];
                worldVertices[w] = vx * a + vy * b + x;
                worldVertices[w + 1] = vx * c + vy * d + y;
            }
            return;
        }
        let v = 0, skip = 0;
        for (let i = 0; i < start; i += 2) {
            let n = bones[v];
            v += n + 1;
            skip += n;
        }
        let skeletonBones = skeleton.bones;
        if (deformArray.length == 0) {
            for (let w = offset, b = skip * 3; w < count; w += stride) {
                let wx = 0, wy = 0;
                let n = bones[v++];
                n += v;
                for (; v < n; v++, b += 3) {
                    let bone = skeletonBones[bones[v]];
                    let vx = vertices[b], vy = vertices[b + 1], weight = vertices[b + 2];
                    wx += (vx * bone.a + vy * bone.b + bone.worldX + ofx) * weight;
                    wy += (vx * bone.c + vy * bone.d + bone.worldY + ofy) * weight;
                }
                worldVertices[w] = wx;
                worldVertices[w + 1] = wy;
            }
        }
        else {
            let deform = deformArray;
            for (let w = offset, b = skip * 3, f = skip << 1; w < count; w += stride) {
                let wx = 0, wy = 0;
                let n = bones[v++];
                n += v;
                for (; v < n; v++, b += 3, f += 2) {
                    let bone = skeletonBones[bones[v]];
                    let vx = vertices[b] + deform[f], vy = vertices[b + 1] + deform[f + 1], weight = vertices[b + 2];
                    wx += (vx * bone.a + vy * bone.b + bone.worldX + ofx) * weight;
                    wy += (vx * bone.c + vy * bone.d + bone.worldY + ofy) * weight;
                }
                worldVertices[w] = wx;
                worldVertices[w + 1] = wy;
            }
        }
    }
}
